const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Wraps fetch with automatic retry on network-level failures (e.g. ERR_HTTP2_PROTOCOL_ERROR).
 * Each retry opens a fresh connection, bypassing the broken HTTP/2 stream.
 */
export async function fetchWithRetry(
  input: RequestInfo,
  init?: RequestInit,
  retries = 3,
  delayMs = 800
): Promise<Response> {
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      return await fetch(input, init);
    } catch (err) {
      if (attempt === retries) throw err;
      await delay(delayMs * (attempt + 1));
    }
  }
  throw new Error('fetchWithRetry: unreachable');
}
